// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 此处后端没有提供注释 POST /manual/message/add */
export async function addManualMessage(
  body: API.ManualMessageAddRequest,
  options?: { [key: string]: any }
) {
  return request<API.RString>("/manual/message/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /manual/message/admin/getAll */
export async function getAllManualMessageByAdmin(
  body: API.ManualMessageQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageManualMessage>("/manual/message/admin/getAll", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /manual/message/delete */
export async function deleteManualMessage(
  body: API.DeleteRequest,
  options?: { [key: string]: any }
) {
  return request<API.RString>("/manual/message/delete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /manual/message/get */
export async function getManualMessageStartVo(options?: {
  [key: string]: any;
}) {
  return request<API.RManualMessageStartVO>("/manual/message/get", {
    method: "GET",
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /manual/message/getAll */
export async function getAllManualMessage(
  body: API.ManualMessageQueryRequest,
  options?: { [key: string]: any }
) {
  return request<API.RPageManualMessage>("/manual/message/getAll", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /manual/message/update */
export async function updateManualMessage(
  body: API.ManualMessage,
  options?: { [key: string]: any }
) {
  return request<API.RString>("/manual/message/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
